var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.listSize),function(i){return [_c('v-skeleton-loader',{key:'skel-'+i,ref:"skeleton",refInFor:true,staticClass:"mx-auto dimming-skeleton",attrs:{"type":_vm.type}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }